import React, { useMemo } from "react";
import { Card, CardBody, Col, Input, Row, TabPane } from "reactstrap";
import CardHeaderTabs from "../../../../../../../@dhn/components/molecules/card-header-tabs";
import ReactTable from "@dhn/components/molecules/data-table";
import AutoResizeTextarea from "@dhn/components/molecules/auto-resize-textarea";
import { isEmpty } from "lodash";
import ReactFormat from "react-number-format";
import ReactSelect from "react-select";
import DatePicker from "react-datepicker";
import moment from "moment";
import {
  getVisibleMedicalParameters,
  getVisibleParameterGroups,
} from "./utils";

export default function EvaluationParameters({
  onChange,
  onChangeTabParEvalu,
  activeTab,
  tabDataParametersEvaluation,
  isPageModalHistory,
}) {
  const { dataSerched, dataParameterGroupOrder } = tabDataParametersEvaluation;

  const visibleGroups = getVisibleParameterGroups(
    dataSerched,
    dataParameterGroupOrder,
  );
  const dataTable = getVisibleMedicalParameters(
    dataSerched,
    visibleGroups,
  );
  const columns = useMemo(() => {
    const options = [
      {
        value: "true",
        label: "Si",
        label2: "Positivo",
      },
      {
        value: "false",
        label: "No",
        label2: "Negativo",
      },
    ];

    return [
      {
        Header: "Parámetro",
        minWidth: 200,
        accessor: "medicalParameters.name",
      },
      {
        Header: "Unidad de Medida ",
        accessor: "medicalParameters.unitOfMeasurement",
      },
      {
        Header: "Resultados",
        className: "text-center",
        Cell: ({ original }) => {
          const { typeId } = original.medicalParameters || {};
          switch (typeId) {
            case 1:
              return (
                <ReactSelect
                  isDisabled={isPageModalHistory}
                  className="text-left w-100"
                  getOptionLabel={(item) => item.label2}
                  getOptionValue={(item) => item.value}
                  menuPosition="fixed"
                  options={options}
                  value={
                    isEmpty(original?.medicalParameterValue)
                      ? null
                      : options.find(
                          (item) =>
                            item.value === original.medicalParameterValue
                        )
                  }
                  onChange={(item) => {
                    onChangeTabParEvalu(
                      "medicalParameterValue",
                      item.value,
                      original
                    );
                    onChangeTabParEvalu(
                      "medicalParameterTypeId",
                      1,
                      original
                    );
                  }}
                />
              );
            case 2:
              return (
                <ReactSelect
                  isDisabled={isPageModalHistory}
                  className="text-left w-100"
                  getOptionLabel={(item) => item.label}
                  getOptionValue={(item) => item.value}
                  menuPosition="fixed"
                  value={
                    isEmpty(original?.medicalParameterValue)
                      ? null
                      : options.find(
                          (item) =>
                            item.value === original.medicalParameterValue
                        )
                  }
                  onChange={(item) => {
                    onChangeTabParEvalu(
                      "medicalParameterValue",
                      item.value,
                      original
                    );
                    onChangeTabParEvalu(
                      "medicalParameterTypeId",
                      2,
                      original
                    );
                  }}
                  options={options}
                />
              );
            case 3:
              return (
                <ReactFormat
                  className="mt-0 text-right"
                  placeholder="0"
                  fixedDecimalScale={true}
                  thousandSeparator={true}
                  value={parseFloat(original?.medicalParameterValue) || ""}
                  customInput={Input}
                  allowNegative={false}
                  decimalScale={2}
                  suffix="%"
                  disabled={original.arsId === 27 || isPageModalHistory}
                  onValueChange={({ floatValue }) => {
                    onChangeTabParEvalu(
                      "medicalParameterValue",
                      floatValue?.toString(),
                      original
                    );
                    onChangeTabParEvalu(
                      "medicalParameterTypeId",
                      3,
                      original
                    );
                  }}
                />
              );
            case 4:
              return (
                <ReactFormat
                  className="mt-0 text-right"
                  placeholder="0"
                  fixedDecimalScale={true}
                  thousandSeparator={true}
                  value={parseFloat(original?.medicalParameterValue) || ""}
                  customInput={Input}
                  allowNegative={false}
                  decimalScale={2}
                  disabled={isPageModalHistory}
                  onValueChange={({ floatValue }) => {
                    console.log("floatValue", floatValue);

                    onChangeTabParEvalu(
                      "medicalParameterValue",
                      floatValue?.toString(),
                      original
                    );
                    onChangeTabParEvalu(
                      "medicalParameterTypeId",
                      4,
                      original
                    );
                  }}
                />
              );
            case 5:
              return (
                <DatePicker
                  selected={
                    isEmpty(original?.medicalParameterValue)
                      ? null
                      : moment(original?.medicalParameterValue).toDate()
                  }
                  placeholderText="dd/MM/yyyy"
                  dateFormat="dd/MM/yyyy"
                  className="mi-input form-control"
                  calendarClassName="mi-calendar"
                  disabled={isPageModalHistory}
                  onChange={(item) => {
                    onChangeTabParEvalu(
                      "medicalParameterValue",
                      moment(item).format("YYYY-MM-DD"),
                      original
                    );
                    onChangeTabParEvalu(
                      "medicalParameterTypeId",
                      5,
                      original
                    );
                  }}
                />
              );
            default:
              return (
                <Input
                  disabled={isPageModalHistory}
                  value={original?.medicalParameterValue || ""}
                  onChange={({ target: { value } }) => {
                    onChangeTabParEvalu(
                      "medicalParameterValue",
                      value,
                      original
                    );
                    onChangeTabParEvalu(
                      "medicalParameterTypeId",
                      6,
                      original
                    );
                  }}
                />
              );
          }
        },
      },
      {
        Header: "Valor Optimo",
        columns: [
          {
            Header: "Mínimo",
            className: "text-right",
            Cell: ({ original: { medicalParameters: { min, typeId } = {} } }) =>
              [3, 4].includes(typeId) && (
                <ReactFormat
                  value={min === null || min === undefined ? "" : min}
                  thousandSeparator={true}
                  fixedDecimalScale={true}
                  decimalScale={2}
                  displayType="text"
                  suffix={typeId === 3 && "%"}
                />
              ),
          },
          {
            Header: "Máximo",
            className: "text-right",
            Cell: ({
              original: {
                medicalParameters: { max, typeId = null },
              },
            }) =>
              [3, 4].includes(typeId) && (
                <ReactFormat
                  value={max === null || max === undefined ? "" : max}
                  thousandSeparator={true}
                  fixedDecimalScale={true}
                  decimalScale={2}
                  displayType="text"
                  suffix={typeId === 3 && "%"}
                />
              ),
          },
        ],
      },
      {
        Header: "Observación",
        minWidth: 200,
        Cell: ({ original }) => {
          return (
            <AutoResizeTextarea
              disabled={isPageModalHistory}
              onChange={({ target: { value } }) =>
                onChangeTabParEvalu("observation", value, original)
              }
              onKeyDown={(e) => {
                if (e.key === "Enter") e.currentTarget.blur();
              }}
              value={original?.observation || ""}
            />
          );
        },
      },
    ];
  }, [isPageModalHistory, onChangeTabParEvalu]);

  return (
    <TabPane tabId={2} className="p-0 m-0">
      <div className="animated fadeIn">
        <Row form>
          <Col>
            <Card>
              {!isEmpty(visibleGroups) && (
                <CardHeaderTabs
                  tabs={visibleGroups.map((item) => ({
                    id: item.medicalParameterGroupId,
                    name: item.nameParameterGroup,
                  }))}
                  active={activeTab}
                  onClick={(id) => onChange("activeTabParameterEvaluation", id)}
                />
              )}
              <CardBody>
                {isEmpty(visibleGroups) ? (
                  <div className="text-center text-muted py-5" role="status">
                    <i className="fa fa-info-circle fa-2x text-info mb-3" aria-hidden="true" />
                    <p className="mb-1 font-weight-bold">
                      No hay parámetros médicos aplicables para este paciente.
                    </p>
                    <small>
                      Ningún parámetro cumple las condiciones configuradas de edad y sexo. Puede continuar con la cita.
                    </small>
                  </div>
                ) : (
                  <ReactTable
                    defaultPageSize={5}
                    className="my-component__table -striped -highlight"
                    data={dataTable.filter(
                      (item) => item.medicalParameterGroupId === activeTab
                    )}
                    columns={columns}
                  />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </TabPane>
  );
}
